<template>
  <div class="">
    <div class="px-3 mb-3">
      <router-link to="/" class="font-bold underline">Back to Home</router-link>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
